import React from 'react';

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

export const IconPhone = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M4.5 3.5h3l1.2 4-2 1.6a12 12 0 0 0 5.2 5.2l1.6-2 4 1.2v3a1.5 1.5 0 0 1-1.6 1.5A15.5 15.5 0 0 1 3 6.1 1.5 1.5 0 0 1 4.5 3.5z" />
  </svg>
);

export const IconSearch = ({ className }) => (
  <svg className={className} {...base}>
    <circle cx="11" cy="11" r="6.5" />
    <line x1="20" y1="20" x2="15.8" y2="15.8" />
  </svg>
);

export const IconCheckBadge = ({ className }) => (
  <svg className={className} {...base}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8 12.5l2.5 2.5L16 9.5" />
  </svg>
);

export const IconTag = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M11 3H4v7l9.5 9.5a2 2 0 0 0 2.83 0l4.17-4.17a2 2 0 0 0 0-2.83L11 3z" />
    <circle cx="7.5" cy="7.5" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const IconShield = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z" />
  </svg>
);

export const IconTruck = ({ className }) => (
  <svg className={className} {...base}>
    <rect x="1.5" y="7" width="12" height="9" rx="1.2" />
    <path d="M13.5 10.5H17l3 3V16h-2" />
    <circle cx="6" cy="18" r="1.6" />
    <circle cx="16" cy="18" r="1.6" />
  </svg>
);

export const IconCalendar = ({ className }) => (
  <svg className={className} {...base}>
    <rect x="3.5" y="5" width="17" height="15" rx="1.5" />
    <path d="M3.5 9.5h17M8 3v4M16 3v4" />
  </svg>
);

export const IconGear = ({ className }) => (
  <svg className={className} {...base}>
    <circle cx="12" cy="12" r="3.2" />
    <path d="M12 4v2.2M12 17.8V20M4 12h2.2M17.8 12H20M6.3 6.3l1.6 1.6M16.1 16.1l1.6 1.6M6.3 17.7l1.6-1.6M16.1 7.9l1.6-1.6" />
  </svg>
);

export const IconFuel = ({ className }) => (
  <svg className={className} {...base}>
    <rect x="4" y="4" width="10" height="16" rx="1.2" />
    <path d="M7 8h4M15 8.5l3 2.2v6.3a1.5 1.5 0 0 0 3 0V9.5l-2.4-2.6" />
    <path d="M4 12h10" />
  </svg>
);

export const IconGauge = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M4 15a8 8 0 1 1 16 0" />
    <path d="M12 15l4-5" />
    <circle cx="12" cy="15" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const IconCoins = ({ className }) => (
  <svg className={className} {...base}>
    <ellipse cx="9" cy="7" rx="6" ry="3" />
    <path d="M3 7v4c0 1.66 2.69 3 6 3s6-1.34 6-3V7" />
    <path d="M3 11v4c0 1.66 2.69 3 6 3s6-1.34 6-3v-4" />
    <path d="M15 9.4c2.9.3 5 1.5 5 2.9 0 1.66-2.69 3-6 3" />
  </svg>
);

export const IconStar = ({ className }) => (
  <svg className={className} {...base} fill="currentColor" stroke="none">
    <path d="M12 3.2l2.6 5.6 6 .7-4.4 4.2 1.1 6-5.3-3-5.3 3 1.1-6-4.4-4.2 6-.7z" />
  </svg>
);

export const IconCamera = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M4 8h3l1.4-2h7.2L17 8h3v11H4z" />
    <circle cx="12" cy="13.2" r="3.4" />
  </svg>
);

export const IconFlag = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M5 21V4" />
    <path d="M5 4h13l-2.5 3.5L18 11H5" />
  </svg>
);

export const IconArrowRight = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M4 12h16" />
    <path d="M13 5l7 7-7 7" />
  </svg>
);
